import { THERAPY_ADMIN_STATUS_PRE_THERAPY, THERAPY_ADMIN_STATUS_ON_THERAPY } from 'constants/index';

// TODO: Add all of the other administration statuses.
export enum TherapyAdministrationStatuses {
  OnTherapy = 1002,
  OnHoldAttemptingPregnancy = 1003,
  OnHoldMedicalProcedure = 1004,
  OnHoldPatientUnreachable = 1005,
  OnHoldExcessSupplyOfMeds = 1006,
  OnHoldDrugHoliday = 1007,
  OnHoldLabsOutOfRange = 1043,
  OnHoldOther = 1040,
  OnHoldCurrentlyPregnant = 1038,
  OnHoldMedicationAvailability = 17100,
  OnHoldHospitalization = 1008,
  PreTherapy = 1001,
  MigrationUnknown = 1031,
  MigrationFallthrough = 1032,
}

export const DiscontinuedNoGoTherapyStatuses = [
  1009, 1010, 1011, 1012, 1013, 1014, 1015, 1016, 1017, 1018, 1019, 1020, 1021, 1022, 1023, 1024,
  1025, 1026, 1027, 1028, 1033, 1034, 1035, 1036, 1037, 1039, 1041, 1042,
];

export const THERAPY_ADMINISTRATION_PRE_THERAPY = [
  TherapyAdministrationStatuses.PreTherapy,
  TherapyAdministrationStatuses.MigrationUnknown,
  TherapyAdministrationStatuses.MigrationFallthrough,
];
export const THERAPY_ADMINISTRATION_ON_THERAPY = [TherapyAdministrationStatuses.OnTherapy];
export const THERAPY_ADMINISTRATION_ON_HOLD = [
  TherapyAdministrationStatuses.OnHoldAttemptingPregnancy,
  TherapyAdministrationStatuses.OnHoldMedicalProcedure,
  TherapyAdministrationStatuses.OnHoldPatientUnreachable,
  TherapyAdministrationStatuses.OnHoldExcessSupplyOfMeds,
  TherapyAdministrationStatuses.OnHoldDrugHoliday,
  TherapyAdministrationStatuses.OnHoldHospitalization,
  TherapyAdministrationStatuses.OnHoldCurrentlyPregnant,
  TherapyAdministrationStatuses.OnHoldOther,
  TherapyAdministrationStatuses.OnHoldLabsOutOfRange,
  TherapyAdministrationStatuses.OnHoldMedicationAvailability,
];
export const THERAPY_ADMINISTRATION_INITIATED = THERAPY_ADMINISTRATION_ON_THERAPY.concat(
  THERAPY_ADMINISTRATION_ON_HOLD,
);

export const THERAPY_ACTIVE_STATUS = [
  { label: THERAPY_ADMIN_STATUS_PRE_THERAPY, value: TherapyAdministrationStatuses.PreTherapy },
  { label: THERAPY_ADMIN_STATUS_ON_THERAPY, value: TherapyAdministrationStatuses.OnTherapy },
];
